import { GiftIcon } from '@heroicons/react/24/outline'
import { FormattedNumber } from '@sushiswap/ui'
import type { FC } from 'react'
import React from 'react'
import { KATANA_CHAIN_ID } from 'src/config'
import type { Amount } from 'sushi'
import { formatUSD } from 'sushi'
import type { EvmCurrency } from 'sushi/evm'
import { PortfolioInfoRow } from '../portfolio-info-row'

interface MerklReward {
  tokenAddress: string
  amount: Amount<EvmCurrency>
  amountUSD: number
}

interface PortfolioMerklClaimablesProps {
  rewards: MerklReward[]
}

export const PortfolioMerklClaimables: FC<PortfolioMerklClaimablesProps> = ({
  rewards,
}) => (
  <div className="h-full overflow-y-auto cursor-default">
    {rewards.map(({ tokenAddress, amount, amountUSD }) => (
      <PortfolioInfoRow
        key={tokenAddress}
        chainId={KATANA_CHAIN_ID}
        icon={
          <div className="p-1.5 bg-[#64748B] rounded-full w-7 h-7">
            <GiftIcon className="stroke-2 text-white" />
          </div>
        }
        leftContent={
          <React.Fragment>
            <div className="text-sm font-medium overflow-hidden overflow-ellipsis">
              {amount.currency.symbol ?? 'Unknown'}
            </div>
            <div className="text-xs text-muted-foreground overflow-hidden overflow-ellipsis">
              Merkl Reward
            </div>
          </React.Fragment>
        }
        rightContent={
          <React.Fragment>
            <div className="text-sm font-medium overflow-hidden overflow-ellipsis">
              {formatUSD(amountUSD)}
            </div>
            <div className="text-xs text-muted-foreground overflow-hidden overflow-ellipsis">
              <FormattedNumber number={amount.toSignificant(6)} />{' '}
              {amount.currency.symbol}
            </div>
          </React.Fragment>
        }
      />
    ))}
  </div>
)
